import { Text, useFormInputs } from '@lbcamden/lib-react';
import { FunctionComponent, useEffect } from 'react';

import { whatToDoNextSchema } from '~/common/schemas/pcfra';

import { Container } from '../../PcfraCreateEditPage.styled';
import { SectionFormProps } from '../../types';
import { SectionHeading } from '../common.styled';
import { whatToDoNextFormConfig, WhatToDoNextFormValues } from './config';

export const WhatToDoNext: FunctionComponent<SectionFormProps> = ({
  draftValues,
  showErrors,
  onChange,
}) => {
  const {
    formState: { data },
    formInputs,
  } = useFormInputs<WhatToDoNextFormValues>({
    schema: whatToDoNextSchema,
    config: whatToDoNextFormConfig,
    value: draftValues?.whatToDoNext as WhatToDoNextFormValues,
    showErrors,
  });

  useEffect(() => {
    onChange({ whatToDoNext: data });
  }, [data]);

  return (
    <>
      <Container>
        <SectionHeading>What to do next</SectionHeading>
        <Text $weight={600}>
          If any of the questions 1-3 have been answered ‘Yes’, or there are no smoke/heat alarms
          fitted (or they are broken or poorly sited), this suggests there is a risk from fire.
          Immediate actions are required to ensure safety measures are in place:
        </Text>
        <ol>
          <li>
            Return this checklist to FireAdvisors@camden.gov.uk. They will assist with a more
            comprehensive assessment of the resident and their home.
          </li>
          <li>
            Inform the resident/family/carers of the risks identified, if you are certain they will
            understand. Discuss safer behaviours if this is appropriate e.g. not smoking in bed,
            keeping candles away from flammable materials, not leaving cooking unattended.
          </li>
          <li>If a care plan exists, all actions taken should be noted in that plan.</li>
          <li>Ensure appropriate partnership referrals are made as required.</li>
        </ol>
      </Container>

      <Container>
        <SectionHeading>Home Fire Safety Visit</SectionHeading>
        <Text>
          If you would like to recommend a HFSV by the LFB on behalf of the resident, complete the
          Home Fire Safety Checker available from the London Fire Brigade website:{' '}
          <a
            href="https://www.london-fire.gov.uk/home-fire-safety-checker/"
            target="_blank"
            rel="noreferrer"
          >
            Home Fire Safety Checker | London Fire Brigade
          </a>
        </Text>
      </Container>

      <Container>
        <SectionHeading>Before moving on</SectionHeading>
        {formInputs}
      </Container>
    </>
  );
};
